_ = require('underscore');
module.exports = {
    "aboveFoldPriceTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="product-price-current icon-inline-right product-price-item"\n          data-tracking-position="view price link - product page - under product title"\n          data-tracking-action="view price">\n    </span>\n';
return __p
},
    "aboveFoldPriceUponRequestTextTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="item-price-upon-request">Price Upon Request</span>\n';
return __p
},
    "aboveFoldInitialPriceTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="product-price-initial-wrapper">\n        Reduced From <span class="product-price-initial product-price-item"></span>\n    </span>\n';
return __p
},
    "aboveFoldSoldHoldTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="icon ' +
((__t = ( obj.classes )) == null ? '' : __t) +
'" data-gastorecount="' +
((__t = ( obj.gastorecount )) == null ? '' : __t) +
'">\n        ' +
((__t = ( obj.copy )) == null ? '' : __t) +
'\n    </span>\n';
return __p
},
    "soldPriceTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="icon is-' +
((__t = ( obj.status )) == null ? '' : __t) +
'" data-gastorecount="' +
((__t = ( obj.gastorecount )) == null ? '' : __t) +
'">\n        ' +
((__t = ( obj.title )) == null ? '' : __t) +
'\n    </span>\n';
return __p
},
    "aboveFoldSoldSuspendedTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n        <span class="icon is-' +
((__t = ( obj.status )) == null ? '' : __t) +
'" data-gastorecount="' +
((__t = ( obj.gastorecount )) == null ? '' : __t) +
'">\n            ' +
((__t = ( obj.title )) == null ? '' : __t) +
'\n        </span>\n\n    ';
 if (obj.status === 'suspended') { ;
__p += '\n        <a href="' +
((__t = ( obj.link.href )) == null ? '' : __t) +
'" class="icon-inline-title icon-inline-right"\n            data-gastorecount="' +
((__t = ( obj.gastorecount )) == null ? '' : __t) +
'"\n            data-gaaction="' +
((__t = ( obj.gaaction )) == null ? '' : __t) +
'"\n            data-gamorecount="' +
((__t = ( obj.gamorecount )) == null ? '' : __t) +
'">\n\n            ' +
((__t = ( obj.link.title )) == null ? '' : __t) +
'\n\n            ';
 if (obj.useSvgIcon && obj.svgWrapClass) { ;
__p += '\n                <span class="' +
((__t = ( obj.svgWrapClass )) == null ? '' : __t) +
'"></span>\n            ';
 } ;
__p += '\n        </a>\n    ';
 } ;
__p += '\n';
return __p
},
    "detailsPriceTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="item-data-border text-next-to-icon">\n        <span class="product-price-current item-details-price product-price-item notranslate"></span>\n    </div>\n    <div>\n        <a href="/checkout/id-' +
((__t = ( obj.pk )) == null ? '' : __t) +
'" class="ecom-action purchase-link" rel="nofollow"\n           data-tracking-action="PDP Purchase Clicked"\n           data-tracking-position="pdp purchase link">\n                <span class="icon-inline-title">Purchase</span>\n        </a>\n    </div>\n';
return __p
},
    "detailsInitialPriceTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="product-price-initial item-details-price strike-through product-price-item"></span>\n';
return __p
},
    "detailsPriceUponRequestTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div>\n        <a href="#contact-dealer" class="item-details-price-contact contact-dealer" data-galocation="contact link in pdp - in product description">\n            Price Upon Request\n        </a>\n    </div>\n';
return __p
},
    "detailsSoldHoldTmpl": function(obj) {
var __t, __p = '';
__p += '\n    ' +
((__t = ( obj.copy )) == null ? '' : __t) +
'\n';
return __p
},
    "purchaseButtonTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <a href="/checkout/id-' +
((__t = ( obj.pk )) == null ? '' : __t) +
'" class="ecom-action purchase-link button-large mobile-full-width button-primary" rel="nofollow"\n        data-tracking-action="PDP Purchase Clicked"\n        data-tracking-position="pdp purchase button">\n        Purchase\n    </a>\n';
return __p
},
    "pdpPrintTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="product-price-item">' +
((__t = ( obj.copy )) == null ? '' : __t) +
'</span>\n';
return __p
},
    "pdpPrintIconTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="icon ' +
((__t = ( obj.icon )) == null ? '' : __t) +
'" data-gastorecount="">' +
((__t = ( obj.copy )) == null ? '' : __t) +
'</span>\n';
return __p
},
    "pdpPrintNetTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="bb-pdp-price"></div>\n';
return __p
}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/templates/pdp/price.html
// module id = 3449
// module chunks = 7